import { useProjectSidebarItems } from '_/components/Projects/ProjectSidebar';
import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import { ProjectProvider, useProject } from '_/contexts/ProjectContext';
import React, { ReactNode, useEffect } from 'react';

interface ProjectSectionProps {
  children: ReactNode;
}

/**
 * Sidebar manager that consumes ProjectContext
 * Separated from provider to avoid circular dependency
 */
function ProjectSidebarManager({ children }: ProjectSectionProps) {
  const { selectedProjectSlug } = useProject();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();
  const sidebarItems = useProjectSidebarItems();

  useEffect(() => {
    registerContext(CONTEXT_DEPTH.PROJECT);
    return () => {
      unregisterContext(CONTEXT_DEPTH.PROJECT);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    if (selectedProjectSlug && selectedProjectSlug !== '_new' && sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.PROJECT);
    }
  }, [setSidebarItems, sidebarItems, selectedProjectSlug]);

  return <>{children}</>;
}

/**
 * ProjectSection - Wrapper for project-level pages
 * Combines provider and sidebar manager
 */
function ProjectSection({ children }: ProjectSectionProps) {
  return (
    <ProjectProvider>
      <ProjectSidebarManager>{children}</ProjectSidebarManager>
    </ProjectProvider>
  );
}

export default ProjectSection;
